import { IResponse, IResponseList } from '@/types/common';
import {
  ICreateIllustrationThemeRequest,
  IPreviewIllustrationThemeRequest,
  IUpdateIllustrationThemeRequest,
} from '@/types/request/illustrationTheme';
import {
  IGetDetailIllustrationThemeResponse,
  IGetListIllustrationThemeResponse,
  IPreviewIllustrationThemeResponse,
} from '@/types/response/illustrationTheme';
import axiosClient from '../axiosClient';
import { ENDPOINT } from '../endpoint';

class IllustrationTheme {
  getList = (): Promise<IResponseList<IGetListIllustrationThemeResponse>> =>
    axiosClient.get(ENDPOINT.ILLUSTRATION_THEME.GET_LIST);

  getDetail = (
    id: number,
  ): Promise<IResponse<IGetDetailIllustrationThemeResponse>> =>
    axiosClient.get(
      ENDPOINT.ILLUSTRATION_THEME.GET_DETAIL.replace(':id', String(id)),
    );

  create = (
    body: ICreateIllustrationThemeRequest,
  ): Promise<IResponse<IGetDetailIllustrationThemeResponse>> =>
    axiosClient.post(ENDPOINT.ILLUSTRATION_THEME.CREATE, body);

  update = (
    body: IUpdateIllustrationThemeRequest,
    id: number,
  ): Promise<IResponse<IGetDetailIllustrationThemeResponse>> =>
    axiosClient.put(
      ENDPOINT.ILLUSTRATION_THEME.UPDATE.replace(':id', String(id)),
      body,
    );

  delete = (id: number) =>
    axiosClient.delete(
      ENDPOINT.ILLUSTRATION_THEME.DELETE.replace(':id', String(id)),
    );

  // OpenAI生成は数十秒かかるため timeout を延長
  previewImage = (
    body: IPreviewIllustrationThemeRequest,
  ): Promise<IResponse<IPreviewIllustrationThemeResponse>> =>
    axiosClient.post(ENDPOINT.ILLUSTRATION_THEME.PREVIEW_IMAGE, body, {
      timeout: 120000,
    });
}

export const IllustrationThemeService = new IllustrationTheme();
